import Vue from "vue";
import Clickoutside from 'element-ui/src/utils/clickoutside';
Vue.directive('drag', {
  inserted (el) {
    // console.log(el)
  },
  bind (el, binding, vNode) {
    if (!el.draggable) return
    el.ondragstart = e => {
      e.dataTransfer.setData('Data', JSON.stringify(binding.value))
    }
    el.style.cursor = 'grab'
    el.onmousedown = (e) => {
      el.style.cursor = 'grabbing'
      document.onmouseup = (e) => {
        document.onmousemove = null
        document.onmouseup = null
        el.style.cursor = 'grab'
      }
    }

    el.onmouseup = e => {
      console.log(e);
      document.onmousemove = null
      document.onmouseup = null
      el.style.cursor = 'grab'
    }
  }
})
Vue.directive('drop', {
  inserted (el) {
    // console.log(el)
  },
  bind (el, binding, vNode) {
    el.ondragover = (e) => {
      e.preventDefault()
    }
    el.ondrop = (e) => {
      e.preventDefault()
      const data = JSON.parse(e.dataTransfer.getData('data'))
      if (vNode.context.getDragData !== undefined) {
        vNode.context.getDragData(data)
      }
    }
  }
})

Vue.directive('clickoutside', Clickoutside)



// WEBPACK FOOTER //
// ./src/assets/js/directive.js